'use client';

export { ErrorBoundary as TaloErrorBoundary } from '@highlight-run/react'